// ---------------------------------------------------------------------------
// Replace these values when the studio name and contacts are finalised.
// Every brand string, contact detail, editable placeholder and image lives
// here so the entire site can be re-skinned from a single file.
// ---------------------------------------------------------------------------

export const site = {
  studioName: "VENDRA",

  // Contact placeholders
  email: "vendraagency@itsvendra.com",
  instagram: "",
  instagramUrl: "",
  whatsapp: "",
  whatsappUrl: "",
  calendarLink: "",

  // Payment line. Enquiry-first, no rate card. Crypto refs removed from
  // public copy; card + bank transfer only, on a private invoice.
  paymentLine:
    "Payment via secure invoice. Card or bank transfer, sent privately after your proposal is approved.",
};

// ---------------------------------------------------------------------------
// SHIP-GUARD — while true, a warning strip renders on non-production builds
// listing every placeholder value still in place. It never renders in a
// production build. Flip to false only once real values are in.
// ---------------------------------------------------------------------------
export const hasPlaceholders = true;

// ---------------------------------------------------------------------------
// EDITABLE PLACEHOLDERS — every figure below renders with a visible
// "placeholder" tag in the UI until it is replaced with the real value.
// This is the single list of everything that must be confirmed before launch.
// ---------------------------------------------------------------------------
export const placeholders = {
  heroFilmDuration: "45–60 seconds",
  cutdownDuration: "6–15 seconds",
  firstCutDays: "5 working days",
  turnaroundDays: "10 working days",
  revisionRounds: "2 revision rounds",
  licenceTerms: "worldwide, all channels, 24 months",
  programmeCadence: "4 films per quarter",
  responseTime: "one working day",
  demonstrationStills: "S01–S22 demonstration frames (src/config/media.js)",
  demonstrationFilms: "F01–F15 treatment examples (src/config/media.js)",
};

// ---------------------------------------------------------------------------
// PROOF — never invented. Case studies appear only when a client has given
// written permission. Shape: { property, brief, constraint, made, happened }.
// Leave empty rather than filling with fiction.
// ---------------------------------------------------------------------------
export const caseStudies = [];

// Atmosphere imagery. Treated heavily in-app to sit in the ink palette.
export const images = {
  brandFilm: "https://images.unsplash.com/photo-1599696848652-f0ff23bc911f?crop=entropy&cs=srgb&fm=jpg&q=75&w=1600",
  deliverables: "https://images.unsplash.com/photo-1590490360182-c33d57733427?crop=entropy&cs=srgb&fm=jpg&q=60&w=1200",
  process: "https://images.unsplash.com/photo-1519681393784-d120267933ba?crop=entropy&cs=srgb&fm=jpg&q=60&w=1200",
  pricing: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?crop=entropy&cs=srgb&fm=jpg&q=60&w=1200",
  footer: "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2200",
};
